module.exports = __webpack_public_path__ + "static/media/know03.3cb9c940.jpg";